import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { WebService } from 'src/app/services/api/web.service'
import { UserAPIModel } from 'src/app/models/api.model'
import { Observable, Subscription, map, startWith } from 'rxjs'
import { FormControl, Validators } from '@angular/forms'

@Component({
  selector: 'app-assign-to-selector',
  templateUrl: './assign-to-selector.component.html',
  styleUrls: ['./assign-to-selector.component.scss']
})
export class AssignToSelectorComponent implements OnInit {
  @Output() selectedValueChange: EventEmitter<string> = new EventEmitter<string>()
  selectedId: string
  @Input('selectedId')
  set receivedSelectedId(id: string) {
    this.selectedId = id
    this.setToValueToControl(id)
  }
  assignees: UserAPIModel[]
  assigneesSubscription$: Subscription
  assigneeFormControl: FormControl = new FormControl('', Validators.required)
  filteredAssignees: Observable<UserAPIModel[]>
  @Input() mandatory: boolean = true
  @Input() asLabel: boolean = false
  @Input() includeInactives: boolean = false

  constructor(private webService: WebService) {}

  private setToValueToControl(id: string) {
    if (id) {
      this.assigneeFormControl.setValue(id)
      if (this.displayFn(id)) {
        this.onSelect(id)
      }
    }
  }

  ngOnInit(): void {
    this.callGetAssigneeListAPI()
  }

  callGetAssigneeListAPI() {
    this.assigneesSubscription$ = this.webService
      .get('/assignee/list')
      .pipe(map((data: UserAPIModel[]) => data))
      .subscribe(assignees => {
        this.assignees = this.includeInactives
          ? assignees
          : assignees?.filter(user => user.status?.toUpperCase() === 'ACTIVE')
        this.setToValueToControl(this.selectedId)
        this.filteredAssignees = this.assigneeFormControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || ''))
        )
      })
  }

  onSelect(selectedValue: string) {
    this.selectedValueChange.emit(selectedValue)
  }

  private _filter(value: string): UserAPIModel[] {
    const filterValue = this._normalizeValue(value)
    return this.assignees?.filter(
      assignee =>
        this._normalizeValue(assignee.fullName).includes(filterValue) ||
        this._normalizeValue(assignee.employeeCode).includes(filterValue) ||
        this._normalizeValue(assignee.id).includes(filterValue)
    )
  }

  private _normalizeValue(value: string): string {
    return value?.toLowerCase().replace(/\s/g, '')
  }

  displayFn(value?: string) {
    return (value && this.assignees?.filter(_ => _.id === value)?.[0]?.fullName) || undefined
  }

  ngOnDestroy() {
    this.assigneesSubscription$?.unsubscribe()
  }
}
